module.exports = __webpack_public_path__ + "static/media/Conquistador.d0c18043.jpg";